/* Elevate design system – small, dependency-free helpers */
(function () {
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function show(el) {
    el.classList.add('is-in');
    if (el.matches('[data-es-count]')) count(el);
    el.querySelectorAll('[data-es-count]').forEach(count);
    el.querySelectorAll('[data-es-bar]').forEach(function (b) { b.style.width = b.getAttribute('data-es-bar') + '%'; });
  }

  function count(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var raw = el.getAttribute('data-es-count');
    var to = parseFloat(raw);
    if (isNaN(to)) return;
    var dec = (raw.split('.')[1] || '').length;
    var t0 = performance.now();
    function step(t) {
      var p = Math.min((t - t0) / 1400, 1);
      el.textContent = (to * (1 - Math.pow(1 - p, 3))).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function timers(root) {
    root.querySelectorAll('[data-es-countdown]').forEach(function (el) {
      if (el._esT) clearInterval(el._esT);
      var end = Date.parse(el.getAttribute('data-es-countdown'));
      if (isNaN(end)) return;
      var units = el.querySelectorAll('b');
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0 && el.getAttribute('data-hide') === 'true' && !window.Shopify?.designMode) el.hidden = true;
        var v = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
        units.forEach(function (b, i) { b.textContent = String(v[i]).padStart(2, '0'); });
      }
      tick();
      el._esT = setInterval(tick, 1000);
    });
  }

  function marquees(root) {
    root.querySelectorAll('[data-es-marquee]').forEach(function (m) {
      var track = m.querySelector('.es-marquee__track');
      var group = track && track.querySelector('.es-marquee__group');
      if (!group || !group.children.length) return;
      track.querySelectorAll('[data-es-clone]').forEach(function (c) { c.remove(); });
      var w = group.scrollWidth || 1;
      var n = Math.max(1, Math.ceil(window.innerWidth / w));
      for (var i = 1; i < n * 2; i++) {
        var c = group.cloneNode(true);
        c.setAttribute('data-es-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('[data-shopify-editor-block]').forEach(function (x) { x.removeAttribute('data-shopify-editor-block'); });
        track.appendChild(c);
      }
      var speed = parseFloat(m.getAttribute('data-speed')) || 60;
      track.style.setProperty('--dur', ((w * n) / speed).toFixed(2) + 's');
    });
  }

  function sliders(root) {
    root.querySelectorAll('[data-es-slider]').forEach(function (s) {
      if (s._esS) return;
      s._esS = true;
      var track = s.querySelector('.es-slider');
      s.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var first = track.firstElementChild;
          var w = first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
          track.scrollBy({ left: w * Number(btn.getAttribute('data-dir')), behavior: 'smooth' });
        });
      });
    });
  }

  function stickies(root) {
    root.querySelectorAll('[data-es-sticky]').forEach(function (el) {
      if (el._esK) return;
      el._esK = true;
      var off = Number(el.getAttribute('data-offset')) || 600;
      function f() {
        var nearEnd = window.innerHeight + window.scrollY >= document.body.scrollHeight - 250;
        el.classList.toggle('is-on', window.scrollY > off && !nearEnd);
      }
      window.addEventListener('scroll', f, { passive: true });
      f();
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.es-reveal').forEach(function (el) {
      if (io) io.observe(el); else show(el);
    });
    timers(root);
    marquees(root);
    sliders(root);
    stickies(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { marquees(document); }, 200); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { e.target.classList && e.target.classList.add('is-in'); });
})();
